import { Container, BoxSelect, BtnSearch, Content, Card, Table } from './styled';
import { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import { DatePicker, InputList } from '../../../../components';
import { getUsers } from '../../../../service/serviceChat/usersService';
import { useAuth } from '../../../../contexts/auth';
import { apiAdmin } from '../../../../service/api';
import { RiCustomerService2Fill } from 'react-icons/ri';
import { IoIosSearch, IoIosVideocam } from 'react-icons/io';
import { FaUsers, FaFilePdf } from 'react-icons/fa6';
import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';


export function VideoCall() {
  const [dateStart, setDateStart] = useState(moment().subtract(1, 'months').format('YYYY-MM-DD'));
  const [dateEnd, setDateEnd] = useState(moment().format('YYYY-MM-DD'));
  const [qtdUsers, setQtdUsers] = useState(0);
  const [qtdCustomers, setQtdCustomers] = useState(0);
  const [qtdVideoCall, setQtdVideoCall] = useState(0);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState({ id: '', name: 'Todos Usuários' });
  const [users, setUsers] = useState([]);
  const [detailsUser, setDetailsUser] = useState(null);

  const { company_id } = useAuth();

  const searchUsers = useCallback(async () => {
    try {
      const res = await getUsers();
      if (res) {
        setUsers([{ id: '', nomecompleto: 'Todos Usuários' }, ...res]);
      }
    } catch (error) {
      console.error('Erro ao buscar usuários:', error);
    }
  }, []);

  const searchDataVideoCall = async (dateStart, dateEnd) => {
    try {
      setLoading(true);

      let url = `/atendimentos-usuario-paciente?dt_ini=${dateStart}&dt_fim=${dateEnd}&empresa_id=${company_id}`;
      if (selectedUser?.id) url += `&user_id=${selectedUser.id}`;

      const { data } = await apiAdmin.get(url);
      setData(data.detalhes);
      setQtdUsers(data.total_usuarios);
      setQtdCustomers(data.quantidade_pacientes);
      setQtdVideoCall(data.quantidade_atendimentos);
      setDetailsUser(null);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    searchUsers();
    searchDataVideoCall(
      moment(dateStart).format('DD/MM/YYYY'),
      moment(dateEnd).format('DD/MM/YYYY')
    );
  }, []);

  const handleSelectUser = (user_id) => {
    const userDetails = data.find((item) => item.user_id === user_id);
    setDetailsUser(userDetails || null);
  };

  const handleGeneratePDF = async () => {
    const sanitizeText = (text) => {
      if (!text) return '';
      return text.replace(/[^\x00-\x7F]/g, '');
    };
  
    try {
      const pdfDoc = await PDFDocument.create();
      const fontNormal = await pdfDoc.embedFont(StandardFonts.Helvetica);
      const fontBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
  
      let page = pdfDoc.addPage([595, 842]);
      let { height, width } = page.getSize();
  
      let y = height - 50;
      const marginLeft = 50;
      const maxWidth = width - marginLeft * 2;
      const fontSizeNormal = 10;
      const fontSizeTitle = 12;
      const lineGap = 16;
  
      const wrapText = (text, font, size, maxWidth) => {
        const words = text.split(' ');
        const lines = [];
        let line = '';
  
        for (let word of words) {
          const testLine = line ? `${line} ${word}` : word;
          const textWidth = font.widthOfTextAtSize(testLine, size);
          if (textWidth > maxWidth) {
            lines.push(line);
            line = word;
          } else {
            line = testLine;
          }
        }
        if (line) lines.push(line);
        return lines;
      };
  
      const drawText = (text, options = {}) => {
        const {
          x = marginLeft,
          size = fontSizeNormal,
          font = fontNormal,
          move = lineGap,
        } = options;
  
        const safeText = sanitizeText(String(text));
        const lines = wrapText(safeText, font, size, maxWidth);
  
        for (const line of lines) {
          page.drawText(line, { x, y, size, font });
          y -= move;
          if (y < 60) {
            page = pdfDoc.addPage([595, 842]);
            ({ height, width } = page.getSize());
            y = height - 50;
          }
        }
      };
  
      const checkNewPage = (extraSpace = 60) => {
        if (y < extraSpace) {
          page = pdfDoc.addPage([595, 842]);
          ({ height } = page.getSize());
          y = height - 50;
        }
      };
  
      drawText(
        `Periodo: ${moment(dateStart).format('DD/MM/YYYY')} - ${moment(dateEnd).format('DD/MM/YYYY')}`,
        { size: fontSizeTitle, font: fontBold, move: lineGap + 6 }
      );
  
      const drawUserSection = (userData) => {
        checkNewPage(100);
        drawText(`Usuario: ${userData.user}`, { size: fontSizeTitle, font: fontBold });
        drawText(`Total de atendimentos: ${userData.total_atendimentos}`);
        drawText(`Tempo total: ${userData.tempo_total}`);
  
        y -= 4;
  
        (userData.atendimentos || []).forEach((item) => {
          checkNewPage(80);
  
          const inicio = moment(item.date_hour_init, 'DD-MM-YYYY HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
          const fim = moment(item.date_hour_end, 'DD-MM-YYYY HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
  
          drawText(`Cliente: ${item.client}`);
          drawText(`Início: ${inicio} — Fim: ${fim}`);
          drawText(`Duração: ${item.total_time}`);
  
          y -= 10;
        });
  
        y -= 14;
      };
  
      if (detailsUser) {
        drawUserSection(detailsUser);
      } else {
        for (const userData of data) {
          drawUserSection(userData);
        }
      }
  
      const pdfBytes = await pdfDoc.save();
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
  
      const link = document.createElement('a');
      link.href = url;
      link.download = detailsUser
        ? `relatorio_${(detailsUser.user || 'usuario').replace(/\s+/g, '_')}.pdf`
        : `relatorio_geral_${moment().format('DD-MM-YYYY_HH:mm:ss')}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erro ao gerar PDF:', error);
    }
  };  

  return (
    <Container>
      <BoxSelect>
        <div className='box--'>
          <div className='line-'>
            <DatePicker className='date' value={dateStart} onChange={setDateStart} />
            <span> - </span>
            <DatePicker className='date' value={dateEnd} onChange={setDateEnd} />
          </div>
          <div className='line-'>
            <div className='list-'>
              <InputList
                options={users.map((user) => ({
                  id: user.id,
                  name: user.nomecompleto,
                }))}
                value={selectedUser.name}
                onChange={(value) => setSelectedUser(value)}
                toView='name'
              />
            </div>
            <BtnSearch
              disabled={loading ? 1 : 0}
              onClick={() =>
                searchDataVideoCall(
                  moment(dateStart).format('DD/MM/YYYY'),
                  moment(dateEnd).format('DD/MM/YYYY')
                )
              }
            >
              {loading ? <span className='loader' /> : <IoIosSearch />}
            </BtnSearch>
          </div>
        </div>
      </BoxSelect>

      <Content>
        <div className='area--cards'>
          <Card width='23rem' height='5rem'>
            <div className='icon--'>
              <RiCustomerService2Fill />
            </div>
            <div className='info--'>
              <span className='title--'>Total de Usuários</span>
              <span className='title-- value'>{qtdUsers || '--'}</span>
            </div>
          </Card>

          <Card width='23rem' height='5rem'>
            <div className='icon--'>
              <FaUsers />
            </div>
            <div className='info--'>
              <span className='title--'>Total de Clientes</span>
              <span className='title-- value'>{qtdCustomers || '--'}</span>
            </div>
          </Card>

          <Card width='23rem' height='5rem'>
            <div className='icon--'>
              <IoIosVideocam />
            </div>
            <div className='info--'>
              <span className='title--'>Total de Atendimentos</span>
              <span className='title-- value'>{qtdVideoCall || '--'}</span>
            </div>
          </Card>
        </div>

        <div className='area--table'>
          <Table>
            <div className='area--users'>
              <span
                onClick={() => handleSelectUser('')}
                className={detailsUser === null ? 'active' : ''}
              >
                {`Todos Usuários`}
              </span>
              {data.length > 0 && (
                data.map((item, index) => (
                  <span
                    key={index}
                    onClick={() => handleSelectUser(item.user_id)}
                    className={detailsUser?.user_id === item.user_id ? 'active' : ''}
                  >
                    {item.user}
                  </span>
                ))
              )}
            </div>

            <div className='area--information'>
              {detailsUser ? (
                <>
                  <div className='header--'>
                    <div className='info--user'>
                      <strong>{detailsUser.user}</strong>
                      <span>Total de atendimentos: {detailsUser.total_atendimentos}</span>
                      <span>Tempo total: {detailsUser.tempo_total}</span>
                    </div>
                    <div className='icon--' onClick={handleGeneratePDF} style={{ cursor: 'pointer' }}>
                      <FaFilePdf />
                    </div>
                  </div>
                  <div className='list--attendances'>
                    {detailsUser.atendimentos.map((item, index) => {
                      const formatDate = (dateStr) => {
                        if (!dateStr) return '';
                        const [datePart, timePart] = dateStr.split(' ');
                        return `${datePart.replace(/-/g, '/')}${timePart ? ' ' + timePart : ''}`;
                      };

                      return (
                        <div key={index} className='details--item'>
                          <div><strong>Cliente:</strong> {item.client}</div>
                          <div>
                            <strong>Início:</strong> {formatDate(item.date_hour_init)} —{' '}
                            <strong>Fim:</strong> {formatDate(item.date_hour_end)}{' '}
                            <strong>Duração:</strong> {item.total_time}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              ) : (
                <div>
                  <div>
                    <div
                      className="icon--"
                      onClick={handleGeneratePDF}
                      style={{ cursor: 'pointer' }}
                    >
                      <FaFilePdf />
                    </div>
                  </div>
                  <div className='list--attendances'>
                    {
                      data.map((item, index) => (
                        <div key={index} className="details--item">
                          <div><strong>Usuário:</strong> {item.user}</div>
                          <div><strong>Total de Atendimentos:</strong> {item.total_atendimentos}</div>
                          <div><strong>Tempo total:</strong> {item.tempo_total}</div>
                        </div>
                      ))
                    }
                  </div>
                </div>
              )}
            </div>
          </Table>
        </div>
      </Content>
    </Container>
  );
}